const paymentGateway = require('../common/payment-gateway');

module.exports = {
	init: () => {
		const overDueBalanceDollarsAsString = '' + parseInt(window.iq.overdueBalanceDue, 10) / 100;

		window.jQuery('#membershippayform').on('submit', (e) => {
			if (window.jQuery('#paymentToken').val() === '') {
				paymentGateway.update({
					amountDisplay: '$' + overDueBalanceDollarsAsString,
					fullName: window.iq.fullName,
					email: window.iq.emailAddress,
					street1: window.jQuery('#street1').val(),
					street2: window.jQuery('#street2').val(),
					city: window.jQuery('#city').val(),
					state: window.jQuery('#state').val(),
					postalCode: window.jQuery('#postalCode').val(),
					nation: window.jQuery('#nation').val()
				});
				paymentGateway.tokenize();

				e.preventDefault();
				return false;
			}
			return true;
		});

		if (window.jQuery('#paymentToken').length > 0) {
			paymentGateway.init({
				braintreeConfig: {
					containerId: '#gateway-container',
					submitBtnSelector: '#btnRetryPayment',
					venmo: {
						allowNewBrowserTab: true //set this to false in places where refreshing the page would break it (like a SPA)
					},
					paypal: {
						flow: 'vault'
					},
					applePay: {
						displayName: window.iq.fullName,
						paymentRequest: {
							total: {
								label: 'Membership Fees',
								amount: overDueBalanceDollarsAsString //yes, this one expects the value as a string, but with no dollar sign character prefix
							}
						}
					},
					googlePay: {
						transactionInfo: {
							totalPrice: overDueBalanceDollarsAsString //yes, this one expects the value as a string, but with no dollar sign character prefix
						}
					}
				},
				spreedlyConfig: {
					company_name: window.iq.customerName,
					sidebar_top_description: 'Membership'
				},
				onSubmitting: () => {
					//the button is automatically disabled, this callback allows us to make other UI changes
					//this is only called after tokenization succeeds
					window.jQuery('#btnRetryPayment i').removeClass('fa-credit-card').addClass('fa-circle-o-notch fa-spin');
					window.jQuery('#btnRetryPayment').prop('disabled', true).addClass('disabled');
				}
			});
		}
	}
};
